import styled from 'styled-components';

const CPFColumn = styled.div`
    display: inline-block;
    box-sizing: border-box;
    vertical-align: top;
`;

export default CPFColumn;